// extracted by mini-css-extract-plugin
export var collapsedSummary = "_kc-0";